"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getLaquesisFFCookieName = getLaquesisFFCookieName;
const LAQUESIS_FF_COOKIE_NAME = 'laquesisff';

/** Returns laquesisff cookie name
 *
 * @return {String} laquesisff cookie name
 */
function getLaquesisFFCookieName() {
  return LAQUESIS_FF_COOKIE_NAME;
}
var _default = getLaquesisFFCookieName;
exports.default = _default;